// FS管理相关
import { get, post } from '@/api/base/request';
import { apiPrefix } from '@/api/url';

const {attend, baseApi, aiApi} = apiPrefix;

// 线路配置 - 外呼 - 组织机构选项列表
export const getFsOrgOptions = (params) => {
  return get(`${attend}/task/taskList`, params);
}
// 线路配置 - 外呼 - 线路选项列表
export const getFsLineOptions = (params) => {
  params.type = 'userType';
  return get(`${attend}/lines/lineList`, params);
}
// 线路配置 - 外呼 - 列表
export const getFsLineConfigList = (params) => post(`${attend}/lineProportion/configList`, params);

export const getFsTaskConfigList = (params) => get(`${baseApi}/fsTask/list`, params);

export const fsTaskUpdate = (params) => post(`${baseApi}/fsTask/update`, params);
// 线路配置 - 外呼 - 新增 / 保存
export const fsLineConfigAdd = (params={}) => {
  const {operateType, ...rest} = params;
  // 批量新增
  if (operateType === 'batchAdd') return post(`${attend}/lineProportion/saveMore`, rest);
  // 新增、修改
  return post(`${attend}/lineProportion/saveOne`, rest);
}

// 线路配置 - 点拨 - 组织机构选项列表
export const getFsDbOrgOptions = (params) => {
  return get(`${attend}/skillGroup/skillGroupList`, params);
}
// 线路配置 - 点拨 - 列表
export const getFsDbLineConfigList = (params) => post(`${attend}/sgLineProportion/configList`, params);
// 线路配置 - 点拨 - 新增 / 保存
export const fsDbLineConfigAdd = (params={}) => {
  const {operateType, ...rest} = params;
  // 批量新增
  if (operateType === 'batchAdd') return post(`${attend}/sgLineProportion/saveMore`, rest);
  // 新增、修改
  return post(`${attend}/sgLineProportion/saveOne`, rest);
}



// 线路检测实时报表 - 列表
export const getLosList = (params={}) => {
  const {pageType, ...rest} = params;
  // 实时
  if (pageType === 1) return post(`${attend}/dailyReport/realTime`, params);
  // 历史
  return post(`${attend}/dailyReport/historyDailyReport`, rest);
}
// 线路通话对账月报 - 列表
export const getLcrmsList = (params) => post(`${attend}/monthlyReport/historyMonthlyReport`, params);

// 线路外呼分钟数查询 - 列表
export const getLcdList = (params) => post(`${baseApi}/callOutLineManage/getLineMinutesReport`, params);
// 线路外呼分钟数查询 - 导出
export const lcdExport = (params) => post(`${baseApi}/callOutLineManage/getLineMinutesReport`, params, {responseType: "blob"});

// 线路并发配置 - 列表
export const getLccList = (params) => get(`${baseApi}/fsTask/queryLineList`, params);
// 线路并发配置 - 更新
export const lccUpdate = (params) => post(`${baseApi}/fsTask/updateLine`, params);
// 线路并发配置 - 外呼状态摘除/恢复
export const lccToggleState = (params) => post(`${baseApi}/fsTask/toggleLineState`, params);



// 线路分流配置 - 配置
export const getScriptDivideConfig = (params) => get(`${aiApi}/admin/script-call-allocation/configs`, params);
// 线路分流配置 - 剧本选项
export const getScriptOptions = (params) => get(`${aiApi}/admin/script-call-allocation/script-options`, params);
// 线路分流配置 - 剧本保存
export const scriptDivideSave = (params) => post(`${aiApi}/admin/script-call-allocation/configs`, params);
// 剧本关联短信 - 短信任务选项
export const getScriptSmsAllocationOptions = (params = {}) => get(`${aiApi}/admin/script-sms-allocation/sms-task-options`, params);

// 剧本关联短信 - 配置详情
export const getScriptSmsAllocationConfig = (params = {}) => get(`${aiApi}/admin/script-sms-allocation/configs`, params);
// 剧本关联短信 - 保存配置
export const scriptSmsAllocationSave = (params = {}) => post(`${aiApi}/admin/script-sms-allocation/configs`, params);

// 零犀短信分流 - 使用中的短信明细
export const getLxSmsDiversionActiveList = (params = {}) => get(`${baseApi}/sms/diversion/active/list`, params);
// 零犀短信分流 - 配置列表
export const getLxSmsDiversionConfigList = (params = {}) => get(`${baseApi}/sms/diversion/config/list`, params);
// 零犀短信分流 - 保存配置
export const lxSmsDiversionConfigSave = (params = {}) => post(`${baseApi}/sms/diversion/config/save`, params, {noValid: true});
